/**
 * Step 8: CPF
 * Coleta o número do CPF do usuário
 */

import React, { useState } from 'react';
import { StepContainer, FormFieldGroup, StepNavigation } from '../components';
import { StepProps, useFormContext } from '../context';
import { useFormValidation } from '../hooks';
import { validateCPF } from '../validators';
import { httpInterceptor } from '@/services/http.interceptor';

const Step8_CPF: React.FC<StepProps> = ({ onNext, onPrevious, data, isLoading }) => {
  const { updateFields } = useFormContext();
  const [localData, setLocalData] = useState({ cpfDocument: data.cpfDocument || '' });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [checking, setChecking] = useState(false);

  const formatCPF = (value: string): string => {
    const cleaned = value.replace(/\D/g, '');
    const match = cleaned.match(/(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/);
    
    if (!match) return value;
    
    let formatted = '';
    if (match[1]) formatted = match[1];
    if (match[2]) formatted += `.${match[2]}`;
    if (match[3]) formatted += `.${match[3]}`;
    if (match[4]) formatted += `-${match[4]}`;
    
    return formatted;
  };

  const handleChange = (value: string) => {
    const formatted = formatCPF(value);
    setLocalData({ cpfDocument: formatted });
    setErrors({});
  };

  const handleNext = async () => {
    const validation = validateCPF(localData.cpfDocument);
    
    if (!validation.valid) {
      setErrors({ cpfDocument: validation.error || 'CPF inválido' });
      return;
    }

    // Checar existência do CPF nos pré-cadastros
    setChecking(true);
    try {
      const cpfClean = localData.cpfDocument.replace(/\D/g, '');
      const response = await httpInterceptor.get(`/user/has-pre-register/${cpfClean}`);
      const result = await response.json();

      if (result?.data?.id) {
        setErrors({ cpfDocument: 'Já existe um pré-cadastro com este CPF.' });
        setChecking(false);
        return;
      }
    } catch (error) {
      console.error('Erro ao verificar CPF:', error);
    } finally {
      setChecking(false);
    }

    updateFields(localData);
    onNext(localData);
  };

  return (
    <StepContainer
      title="Qual seu CPF?"
      description=""
    >
       {/*<div className="mb-6">
        <p className="font-semibold mb-2">Qual seu CPF?</p>
        <p className="text-muted-foreground text-sm mb-4">
          Digite seu CPF para validação e análise. Essas informações são sigilosas e apenas para fins de processamento.
        </p> 
      </div>*/}
      <FormFieldGroup
        label="CPF"
        error={errors.cpfDocument}
        required
      >
        <input
          type="text"
          placeholder="123.456.789-01"
          value={localData.cpfDocument}
          onChange={(e) => handleChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-[#5c5c5c]"
        />
      </FormFieldGroup>

      <StepNavigation
        onNext={handleNext}
        onPrevious={onPrevious}
        isLoading={isLoading || checking}
        showPrevious={true}
      />
    </StepContainer>
  );
};

export default Step8_CPF;
